export * from './resource-keys.component';
